module.exports = __webpack_public_path__ + "static/slide-5-877e96c638e4abb818e006d27dd96b88.png";